import { Link } from "react-router-dom";
import { FileText, ExternalLink, ArrowRight } from "lucide-react";

const ITEMS = [
  {
    label: "Patents",
    href: "https://static.showit.co/file/EvPSQlL7RwqDHJB7kBHh1A/229233/x39_patent-1_1.pdf",
    external: true,
  },
  {
    label: "PubMed.gov Article",
    href: "https://pubmed.ncbi.nlm.nih.gov/?term=ghk-cu",
    external: true,
  },
  {
    label: "The Story of the X39 (PDF)",
    href: "https://static.showit.co/file/ilaH5F0ITp2C4M10M6okQQ/117381/lifewave-the-story-of-the-x39.pdf",
    external: true,
  },
  {
    label: "Case Studies",
    href: "/case-studies",
    external: false,
  },
];

export default function Resources() {
  return (
    <section
      id="resources"
      data-testid="resources-section"
      className="relative py-24 lg:py-32 overflow-hidden bg-[#030508]/55"
    >
      <div className="absolute inset-0 bg-grid opacity-10 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#00F0FF]/8 blur-[140px] pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center gap-3 mb-5">
            <span className="relative w-12 h-12 grid place-items-center border border-[#00F0FF]/40 bg-[#00F0FF]/5">
              <FileText className="w-5 h-5 text-[#00F0FF]" strokeWidth={2} />
            </span>
            <span className="text-label">∙ Resources</span>
          </div>
          <h2 className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Science.{" "}
            <span className="text-[#00F0FF] glow-cyan">Receipts.</span>
          </h2>
          <p className="mt-6 text-white/65 leading-relaxed max-w-2xl mx-auto">
            Read the patents, the peer-reviewed PubMed research, and the published
            case studies behind the X39 phototherapy patch.
          </p>
        </div>

        <div className="space-y-4">
          {ITEMS.map((item, i) => {
            const inner = (
              <>
                <div className="flex items-center gap-4 flex-1">
                  <span className="relative w-11 h-11 grid place-items-center border border-[#00F0FF]/40 bg-[#00F0FF]/10 flex-shrink-0 group-hover:bg-[#00F0FF] group-hover:border-[#00F0FF] transition-colors">
                    <FileText
                      className="w-4 h-4 text-[#00F0FF] group-hover:text-black transition-colors"
                      strokeWidth={2.2}
                    />
                  </span>
                  <span className="font-display font-black tracking-wide text-sm sm:text-base lg:text-lg uppercase text-white">
                    {item.label}
                  </span>
                </div>
                <span className="text-[#00F0FF] group-hover:translate-x-1 transition-transform">
                  {item.external ? (
                    <ExternalLink className="w-5 h-5" />
                  ) : (
                    <ArrowRight className="w-5 h-5" />
                  )}
                </span>
              </>
            );
            const classes =
              "group block w-full glass-card px-5 py-5 flex items-center hover:bg-[#00F0FF]/5 transition-colors";
            return item.external ? (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`resource-${i}`}
                className={classes}
              >
                {inner}
              </a>
            ) : (
              <Link
                key={item.label}
                to={item.href}
                data-testid={`resource-${i}`}
                className={classes}
              >
                {inner}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
